import { m as motion } from 'framer-motion';
import { slideInDesktop, slideInMobile } from './variants';

import { PropsWithChildren } from 'react';
import styles from './styles.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { useIsMobile } from '@starsoft/common/hooks';
import { SearchModalProps } from './props';
import { useClickOutside } from '@starsoft/common/hooks';

export default function SearchModal({
  children,
  onClose,
}: PropsWithChildren<SearchModalProps>) {
  const collapsed = useSelector((state: RootState) => state.sideBar.collapsed);
  const isMobile = useIsMobile();
  const ref = useClickOutside({
    onClickOutside: onClose,
    open: true,
  });

  return (
    <>
      <motion.div
        className={`${styles.container}  ${collapsed ? styles['container--collapsed'] : ''}`}
        variants={isMobile ? {} : slideInDesktop}
        animate="visible"
        initial="hidden"
        exit="hidden"
        //@ts-ignore
        ref={ref}
      >
        <div className={styles.container__content}>{children}</div>
      </motion.div>

      <motion.div
        variants={isMobile ? slideInMobile : slideInDesktop}
        animate="visible"
        initial="hidden"
        exit="hidden"
        className={styles.overlay}
      />
    </>
  );
}
